<mat-drawer-container class="sidemenu" autosize>
  <mat-drawer
    #drawer
    mode="side"
    [opened]="!router.url.includes('login')"
    class="links-container"
    [style.width]="isExpanded() ? '320px' : '80px'"
    [disableClose]="true"
  >
    <!-- Botão de Toggle -->
    <button
      mat-icon-button
      class="toggle-button"
      (click)="toggleMenu()"
      [title]="isExpanded() ? 'Recolher menu' : 'Expandir menu'"
    >
      <mat-icon [@rotateIconMenu]="isExpanded() ? 'expanded' : 'collapsed'">
        chevron_left
      </mat-icon>
    </button>
    <div class="logo-container" [class.collapsed]="!isExpanded()">
      @if (isExpanded()) {
        <img
          src="assets/data-safra-logo.png"
          alt="Logo Datasafra"
          class="logo"
        />
      } @else {
        <img
          src="assets/logo-datasafra.svg"
          alt="Logo Datasafra"
          class="logo"
        />
      }
    </div>
    <div class="side-menu-links-container">
      <nav class="sidebar-nav">
        @for (section of menu; track section) {
          @if (section.show?.() !== false) {
            <div class="menu-section">
              <!-- Cabeçalho da Seção -->
              <button
                class="section-header"
                [class.unavailable-product]="section.isUnavailableProduct?.()"
                [class.collapsed-menu]="!isExpanded()"
                [title]="
                  (section.isUnavailableProduct?.() ?? false)
                    ? 'Produto não contratado - Clique para mais informações'
                    : ''
                "
                (click)="onSectionHeaderClick(section)"
                (mouseenter)="onSectionMouseEnter(section, $event)"
                (mouseleave)="onSectionMouseLeave(section)"
              >
                <div class="section-header-content">
                  @if (section.iconType === "svg") {
                    <mat-icon
                      class="section-icon"
                      [class.icon-monitoring]="
                        section.icon === 'monitoring-safra'
                      "
                      [class.icon-historic]="section.icon === 'historic-safra'"
                      [class.icon-agent]="section.icon === 'datasafra-agent'"
                      [svgIcon]="section.icon!"
                    ></mat-icon>
                  } @else {
                    <mat-icon class="section-icon">{{ section.icon }}</mat-icon>
                  }
                  @if (isExpanded()) {
                    <span
                      class="section-label"
                      [@fadeSlide]="isExpanded() ? 'visible' : 'hidden'"
                    >
                      {{ section.name }}
                    </span>
                  }
                </div>
                @if (
                  isExpanded() &&
                  section.children &&
                  section.children.length > 0 &&
                  !section.isUnavailableProduct?.()
                ) {
                  <mat-icon
                    class="expand-icon"
                    [@rotateIcon]="section.expanded ? 'expanded' : 'collapsed'"
                  >
                    chevron_right
                  </mat-icon>
                }
              </button>

              <!-- Submenus expandidos -->
              @if (
                section.expanded &&
                isExpanded() &&
                !section.isUnavailableProduct?.()
              ) {
                <div class="links" [@expandCollapse]>
                  @for (item of section.children; track item) {
                    @if (item.show?.() !== false) {
                      <button
                        disableRipple
                        mat-button
                        class="menu-link"
                        [routerLink]="item.link"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        [disabled]="item.disabled?.() ?? false"
                        [title]="
                          (item.disabled?.() ?? false)
                            ? 'Acesso não permitido para seu perfil'
                            : ''
                        "
                      >
                        <span
                          [@fadeSlide]="isExpanded() ? 'visible' : 'hidden'"
                        >
                          {{ item.name }}
                        </span>
                      </button>
                    }
                  }
                </div>
              }

              <!-- Submenu flutuante para menu recolhido -->
              @if (
                !isExpanded() &&
                hoveredSection === section &&
                section.children &&
                section.children.length > 0 &&
                !section.isUnavailableProduct?.()
              ) {
                <div
                  class="floating-submenu"
                  [style.top.px]="submenuPosition.top"
                  [style.left.px]="submenuPosition.left"
                  (mouseenter)="onSectionMouseEnter(section)"
                  (mouseleave)="onSectionMouseLeave(section)"
                >
                  @for (item of section.children; track item) {
                    @if (item.show?.() !== false) {
                      <button
                        disableRipple
                        mat-button
                        class="menu-link"
                        [routerLink]="item.link"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        [disabled]="item.disabled?.() ?? false"
                        [title]="
                          (item.disabled?.() ?? false)
                            ? 'Acesso não permitido para seu perfil'
                            : ''
                        "
                      >
                        <span>{{ item.name }}</span>
                      </button>
                    }
                  }
                </div>
              }
            </div>
          }
        }
      </nav>
    </div>
  </mat-drawer>
  <mat-drawer-content class="header">
    @if (!router.url.includes("login")) {
      <mat-toolbar color="primary" class="header-container">
        <div class="header-text">
          <div class="title">
            @if (hasParentRoute() && shouldHideBackButton() !== true) {
              <button
                (click)="up()"
                mat-icon-button
                class="action-button"
                title="Voltar à página anterior"
              >
                <mat-icon>arrow_back</mat-icon>
              </button>
            }
            <h2>{{ pageTitle() }}</h2>
            @if (userService.isGeoambiente) {
              <mat-chip class="chip" disableRipple>ADMIN</mat-chip>
            }
            @if (isDebugMode) {
              <mat-chip class="chip debug-chip" disableRipple>
                DEBUG MODE
              </mat-chip>
            }
          </div>
        </div>
        <button
          mat-icon-button
          id="datasafra-agent-header-button"
          title="Abrir Agente DataSafra"
          class="action-button"
          (click)="goToAgentPage()"
        ></button>
        <button
          mat-icon-button
          id="instruction-manual-header-button"
          title="Manual do Usuário"
          class="action-button"
          (click)="openInstructionManual()"
        >
          <mat-icon>help</mat-icon>
        </button>
        <span class="username-font">
          {{ userService.username }}
        </span>
        @if (userAuthenticated) {
          <button
            mat-flat-button
            style="margin-left: 8px"
            (click)="handleSignOut()"
          >
            Sair
          </button>
        }
      </mat-toolbar>
    }
    <mat-divider></mat-divider>
    <div class="page-content">
      <router-outlet></router-outlet>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
